import AxiosInstance from "./api";

export const JournalVoucherSystemLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/journal-voucher-system-ledgers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/journal-voucher-system-ledgers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/journal-voucher-system-ledgers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/journal-voucher-system-ledgers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/journal-voucher-system-ledgers/" + id);
  },
};
